import React from 'react';

import { withStyles } from '@mui/styles';
import classNames from 'classnames';
import PropTypes from 'prop-types';

export const styles = theme => ({
  divider: {
    width: '100%',
    [theme.breakpoints.down('xs')]: {
      maxHeight: '1rem!important',
    },
  },
  extraSmall: {
    height: '1rem',
  },
  small: {
    height: '2rem',
  },
  medium: {
    height: '4rem',
  },
  large: {
    height: '6rem',
  },
});

export function NavDivider({ classes, size = 'small' }) {
  return (
    <div
      className={classNames(classes.divider, {
        [classes.extraSmall]: size === 'extra-small',
        [classes.small]: size === 'small',
        [classes.medium]: size === 'medium',
        [classes.large]: size === 'large',
      })}
    />
  );
}

NavDivider.propTypes = {
  classes: PropTypes.object,
  size: PropTypes.oneOf(['extra-small', 'small', 'medium', 'large']),
};

export default withStyles(styles)(NavDivider);
